import { useEffect, useState } from "react";

function useCurrentTime() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    // Update time immediately
    setTime(new Date());

    // Update every minute
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000); // 1 minute

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return time;
}

function Taskbar({ openWindows, icons, onIconClick, isTaskbarFirstTileDown }) {
  const time = useCurrentTime();

  const Taskbar_Style = {
    position: "fixed",
    bottom: isTaskbarFirstTileDown ? "-25px" : 0,
    left: 0,
    transition: "0.5s all ease ",
    width: "100%",
    height: "30px", //"60px",
    backgroundColor: "#010081", //"#1a4de4", //"rgba(0, 0, 0, 0.5)",
    backgroundImage: "#010081", //"linear-gradient(to Bottom, #3e6effff, #1a4de4)",
    display: "flex",
    alignItems: "center",
    //padding: "0 10px",
    boxSizing: "border-box",
    zIndex: 9000,
    backdropFilter: "blur(5px)",
    borderTop: "2px solid #517cffff", //rgba(255, 255, 255, 0.2)",
  };

  const timeAndDateStyle = {
    fontFamily: "Tahoma, sans-serif",
    color: "white",
    fontSize: "0.95em",
    textShadow: "1px 1px 0 #00000066",
    position: "absolute",
    right: 25,
  };
  // Get all open windows (not minimized or minimized)
  const openWindowsList = Object.values(openWindows || {}).filter(
    (window) => window.isOpen,
  );

  return (
    <div className="taskbar" style={Taskbar_Style}>
      {openWindowsList.map((window) => {
        // Find the corresponding icon data
        const icon = icons.find((i) => i.id === window.id);
        if (!icon) return null;

        return (
          <div
            className="icon_in_taskbar"
            key={window.id}
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "1px",
              cursor: "pointer",
              padding: "3px",
              borderRadius: "2px",
              backgroundColor: window.isMinimized
                ? "rgba(255, 255, 255, 0.05)" // Slightly highlighted for minimized windows
                : "rgba(255, 255, 255, 0.2)", // More highlighted for visible windows
              border: window.isMinimized
                ? "1px solid rgba(255, 255, 255, 0.1)"
                : "1px solid rgba(255, 255, 255, 0.15)",
              transition: "all 0.2s ease",
              "--icon-hover-color": "rgba(196, 244, 252, 0.12)",
            }}
            onClick={() => onIconClick && onIconClick(window.id)}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = window.isMinimized
                ? "rgba(255, 255, 255, 0.1)"
                : "rgba(255, 255, 255, 0.2)";
            }}
            title={`${icon.file_name}${
              window.isMinimized ? " (Minimized)" : ""
            }`}
          >
            <img
              src={icon.icon_source}
              alt={icon.file_name}
              style={{
                width: "auto",
                height: "20px",
                filter: window.isMinimized
                  ? "grayscale(80%) brightness(65%)"
                  : "none",
                opacity: window.isMinimized ? 0.7 : 1, // Slightly faded for minimized windows
                transition: "all 0.2s ease-in",
              }}
            />
          </div>
        );
      })}
      <div style={timeAndDateStyle}>
        {time.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
      </div>
    </div>
  );
}

export default Taskbar;
